import React from 'react';

export interface HumiditySettingStyle04Props {
  value: number;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  loading?: boolean;
  onChange: (value: number) => void;
  label?: string;
}

/**
 * HumiditySetting Style 04 - Stepper
 * Centered stepper with - value% + buttons
 */
export const Style04_Stepper: React.FC<HumiditySettingStyle04Props> = ({
  value,
  min = 30,
  max = 80,
  step = 5,
  disabled = false,
  loading = false,
  onChange,
  label = '目標濕度'
}) => {
  const handleDecrease = () => {
    if (value > min) {
      onChange(value - step);
    }
  };

  const handleIncrease = () => {
    if (value < max) {
      onChange(value + step);
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-sm text-slate-300">{label}</span>
        <span className="text-sm font-bold text-blue-400">{loading ? '...' : `${value}%`}</span>
      </div>
      <div className="flex items-center justify-center gap-4">
        <button
          onClick={handleDecrease}
          disabled={disabled || loading || value <= min}
          className="w-10 h-10 rounded-full bg-slate-700/50 text-white flex items-center justify-center text-xl hover:bg-slate-600/50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
        >
          −
        </button>
        <span className="text-3xl font-bold text-white min-w-[80px] text-center">
          {value}%
        </span>
        <button
          onClick={handleIncrease}
          disabled={disabled || loading || value >= max}
          className="w-10 h-10 rounded-full bg-slate-700/50 text-white flex items-center justify-center text-xl hover:bg-slate-600/50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
        >
          +
        </button>
      </div>
    </div>
  );
};

export default Style04_Stepper;
